const UserTypes = {
  CLIENT: 1,
  PROFESSIONAL: 2,
  SHOPKEEPER: 3,
  REPRESENTATIVE: 4,
  ADMINISTRATOR: 5,
  EDITOR: 6,
  AFFILIATE: 7,
  GUEST: 8,
  PARTNER: 9,
  BALCONISTA: 10,
  GERENTECONTA: 11,
};

export default UserTypes;

export function mapLabel(userType) {
  const mapped = {
    [UserTypes.CLIENT]: 'Cliente',
    [UserTypes.PROFESSIONAL]: 'Profissional',
    [UserTypes.SHOPKEEPER]: 'Lojista',
    [UserTypes.REPRESENTATIVE]: 'Representante',
    [UserTypes.ADMINISTRATOR]: 'Administrador',
    [UserTypes.EDITOR]: 'Editor',
    [UserTypes.AFFILIATE]: 'Afiliado',
    [UserTypes.GUEST]: 'Convidado',
    [UserTypes.PARTNER]: 'Parceiro',
    [UserTypes.BALCONISTA]: 'Balconista',
    [UserTypes.GERENTECONTA]: 'Gerente de Conta',
  };

  return mapped[userType];
}
